import { Config } from '@chegg-wt/core/config'
import fetch from 'isomorphic-unfetch'
import { SourceType } from '../types/core'
import { GetFormResponse } from '../types/forms-api'
import { Style } from '../types/styles-api'

export const getForm = async (
  sourceTypeApiAlias: SourceType['apiAlias'],
  styleId: Style['id']
): Promise<GetFormResponse> => {
  /* TODO: Figure out error cases and whatnot */
  const response = await fetch(
    `${Config.formApiEndpoint}/${sourceTypeApiAlias}/${styleId}`,
    {
      headers: {
        Accept: 'application/json',
      },
    }
  )
  return response.json().then(
    // NOTE: Get rid of this once the issue is fixed server-side
    // See: https://github.com/easybib/easybib-citation/pull/224
    (json) => ({
      ...json,
      form: json.form.replace(/http:\/\/media\.easybib\.com/g, '//media.easybib.com'),
    })
  )
}
